.ci{padding:0.5rem;}